export default __webpack_public_path__ + "static/batisseStas-mobile-23427aaf8157406c9fd1433e6fcbc690.webp";